import React from 'react';
import 'twin.macro';
import { PDFIcon } from 'components/Icons/icons/PDF';
import Tooltip2 from 'components/Tooltip2';
import { useTranslation } from 'react-i18next';
import ButtonLink from 'components/Buttons/Link';

interface Props {
  onQuickDownload: () => void;
  isDownloading: boolean;
  previewLink: string;
  disabled?: boolean;
}

export function DownloadOrPreviewPDFDays(props: Props) {
  const { isDownloading, disabled } = props;
  const { t } = useTranslation(['cahierJournal', 'common']);
  return (
    <Tooltip2 label={t('common:buttons.pdfPreview')}>
      <ButtonLink
        to={props.previewLink}
        loading={isDownloading}
        minimal
        large
        className="onboarding-download-cj"
        disabled={disabled}
        icon={PDFIcon as any}
      />
    </Tooltip2>
  );
}
